import { combineReducers } from 'redux';
import adrData from '@rsos/components/capstone/DataCards/adrDataSlice';
import axon from '@rsos/components/capstone/common/Map/useDeckGL/Axon/axonSlice';
import eagleEye from '@rsos/components/capstone/common/Map/useDeckGL/EagleEye/eagleEyeSlice';
import mapPopover from '@rsos/components/capstone/common/Map/useDeckGL/MapPopover/mapPopoverSlice';
import chat from '@rsos/reduxDataStore/src/features/alerts/chatSlice';
import incidents from '@rsos/reduxDataStore/src/features/alerts/incidentsSlice';
import alertsRouting from '@rsos/reduxDataStore/src/features/alertsRouting/alertsRoutingSlice';
import appLauncher from '@rsos/reduxDataStore/src/features/appLauncher/appLauncherSlice';
import psaps from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';
import { displaySchemaApi } from '@rsos/reduxDataStore/src/features/displaySchema/displaySchemaApi';
import emergencyCalls from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';
import gisSearch from '@rsos/reduxDataStore/src/features/gisSearch/gisSearchSlice';
import { getSuggestedAddressesApi } from '@rsos/reduxDataStore/src/features/gisSearch/helpers';
import gisServices from '@rsos/reduxDataStore/src/features/gisServices/gisServicesSlice';
import hoveredIncident from '@rsos/reduxDataStore/src/features/incidentInteractions/hoveredIncidentSlice';
import mapCard from '@rsos/reduxDataStore/src/features/mapCard/mapCardSlice';
import peerAgencies from '@rsos/reduxDataStore/src/features/peerAgencies/peerAgenciesSlice';
import { rsosApi } from '@rsos/reduxDataStore/src/features/rsosApi';
import textFrom911 from '@rsos/reduxDataStore/src/features/textFrom911/textFrom911Slice';
import what3words from '@rsos/reduxDataStore/src/features/what3words/what3wordsSlice';
import schemas from '@rsos/schema-storage';
import { sinatra } from '@rsos/sinatra';
import avive from '../components/JurisdictionView/AviveAED/aviveSlice';
import rade from '../components/JurisdictionView/RADECard/radeSlice';
import search from '../components/JurisdictionView/UniversalSearch/searchSlice';
import app from '../reducers/appReducer';
import geofences from '../reducers/geofences';
import medicalert from '../reducers/medicalert';
import spatialLayers from '../reducers/spatialLayers';

const rootReducer = combineReducers({
  adrData,
  alertsRouting,
  app,
  appLauncher,
  avive,
  axon,
  chat,
  [displaySchemaApi.reducerPath]: displaySchemaApi.reducer,
  eagleEye,
  emergencyCalls,
  geofences,
  [getSuggestedAddressesApi.reducerPath]: getSuggestedAddressesApi.reducer,
  gisSearch,
  gisServices,
  hoveredIncident,
  incidents,
  mapCard,
  mapPopover,
  medicalert,
  peerAgencies,
  psaps,
  rade,
  [rsosApi.reducerPath]: rsosApi.reducer,
  schemas,
  search,
  spatialLayers,
  sinatra,
  textFrom911,
  what3words,
});

export default rootReducer;
